
import 'components/catalog.tag'
import 'modals/import-products-modal.tag'
import 'modals/import-products-modal-continue.tag'
import 'modals/export-products-modal.tag'
import 'pages/products/products/product-new-modal.tag'
import 'pages/products/groups/groups-list.tag'
import './markup-modal.tag'
import './price-modal.tag'
import './product-edit-modifications-modal.tag'
import './product-edit-parameters-modal.tag'
riot.tag2('products-list', '  <div class="row">\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="Category" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" deselall="true" descendants="true" handlers="{handlersGroups}"></catalog-tree>\n    </div>\n\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog search="true" sortable="true" object="Product" cols="{cols}" combine-filters="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(productOpen, &quot;products&quot;, &quot;1000&quot;)}" handlers="{handlers}" allselect="true" reload="true" store="products-list" filters="{categoryFilters}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="flagHit" data-bool="Y,N">Хиты\n                </label>\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="flagNew" data-bool="Y,N">Новинки\n                </label>\n                <label class="checkbox-inline">\n                  <input type="checkbox" data-name="specialOffer" data-bool="Y,N">Спецпредложения\n                </label>\n              </div>\n              <div class="form-group" if="{parent.labels.length}">\n                <select class="form-control" data-name="idLabel" onchange="{parent.selectLabel}">\n                  <option value="">Все ярлыки</option>\n                  <option each="{label, i in parent.labels}" value="{label.id}" no-reorder>{label.name}</option>\n                </select>\n              </div>\n              <div class="form-group">\n                <div class="input-group" style="width: 48%; float: left; margin: 0 2% 0 0;"><span class="input-group-addon"><i class="fa fa-percent"></i></span>\n                  <select class="form-control" data-name="discount">\n                    <option value="">Все</option>\n                    <option value="Y">Со скидкой</option>\n                    <option value="N">Без скидки</option>\n                  </select>\n                </div>\n                <div class="input-group" style="width: 48%; float: left; margin: 0 0 0 2%;"><span class="input-group-addon"><i class="fa fa-eye"></i></span>\n                  <select class="form-control" data-name="enabled">\n                    <option value="">Все</option>\n                    <option value="Y">Отображаемые</option>\n                    <option value="N">Неотображаемые</option>\n                  </select>\n                </div>\n              </div>\n              <div class="form-group">\n                <select class="form-control" data-name="idBrand" onchange="{parent.selectBrand}">\n                  <option value="">Все бренды</option>\n                  <option each="{brand, i in parent.brands}" value="{brand.id}" no-reorder>{brand.name}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </yield>\n\n        <yield to="head">\n          <div class="dropdown" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n            <ul class="dropdown-menu">\n              <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.multiEdit}"><a href="#"><i class="fa fa-fw fa-pencil"></i> Мультиредактирование товаров</a></li>\n              <li class="{disabled: selectedCount &gt; 1}" onclick="{handlers.cloneProduct}"><a href="#"><i class="fa fa-fw fa-clone"></i> Клонирование товара</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="enabled"><i class="fa fa-fw fa-eye"></i> Видимость (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="flagNew"><i class="fa fa-fw fa-asterisk"></i> Новинка (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="flagHit"><i class="fa fa-fw fa-star"></i> Хит (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleBool}"><a href="#" data-field="isMarket"><i class="fa fa-fw fa-money"></i> Маркет (вкл/выкл)</a></li>\n              <li onclick="{handlers.toggleSelected}"><a href="#" data-field="specialOffer"><i class="fa fa-fw fa-check"></i> Спец.</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setCategory}"><a href="#"><i class="fa fa-fw"></i> Переопределить категорию</a></li>\n              <li onclick="{handlers.setBrand}"><a href="#"><i class="fa fa-fw"></i> Назначить бренд</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setAddCategory}"><a href="#"><i class="fa fa-fw"></i> Назначить доп. категории</a></li>\n              <li onclick="{handlers.addCategory}"><a href="#"><i class="fa fa-fw"></i> Добавить доп. категории</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setFeatures}"><a href="#"><i class="fa fa-fw"></i> Назначить характеристики</a></li>\n              <li onclick="{handlers.addFeatures}"><a href="#"><i class="fa fa-fw"></i> Добавить характеристики</a></li>\n              <li onclick="{handlers.showFeatures}"><a href="#"><i class="fa fa-fw"></i> Отображать атрибуты на сайте</a></li>\n              <li onclick="{handlers.hideFeatures}"><a href="#"><i class="fa fa-fw"></i> Скрывать атрибуты на сайте</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setModifications}"><a href="#"><i class="fa fa-fw"></i> Назначить модификации</a></li>\n              <li onclick="{handlers.addModifications}"><a href="#"><i class="fa fa-fw"></i> Добавить модификации</a></li>\n              <li class="divider"></li>\n              <li onclick="{handlers.setPrice}"><a href="#"><i class="fa fa-fw fa-money"></i> Задать цены</a></li>\n              <li onclick="{handlers.setMarkup}"><a href="#"><i class="fa fa-fw"></i> Произвести наценку</a></li>\n            </ul>\n          </div>\n          <yield to="head">\n            <button class="btn btn-primary" type="button" onclick="{parent.exportProducts}" title="Экспорт"><i class="fa fa-upload"></i></button>\n            <button class="btn btn-primary" if="{checkPermission(&quot;products&quot;, &quot;0111&quot;)}" type="button" onclick="{parent.importProducts}" title="Импорт"><i class="fa fa-download"></i></button>\n          </yield>\n        </yield>\n\n        <yield to="body">\n          <datatable-cell name="id" style="max-width: 80px;"><a class="open-page-item" href="#products/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n          <datatable-cell name="img" style="max-width: 50px; overflow: hidden;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 40px;"></datatable-cell>\n          <datatable-cell name="article" style="max-width: 100px;" title="{row.article}">{row.article}</datatable-cell>\n          <datatable-cell name="name" style="min-width: 150px; overflow: hidden; text-overflow: ellipsis;" title="{row.name}">{row.name}</datatable-cell>\n\n          <datatable-cell name="stock" style="max-width: 80px;">{row.stock}</datatable-cell>\n          <datatable-cell name="nameBrand" style="max-width: 80px; overflow: hidden; text-overflow: ellipsis;">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="nameGroup" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis;">{row.nameGroup}</datatable-cell>\n          <datatable-cell name="sort" style="max-width: 50px;">{row.sort}</datatable-cell>\n          <datatable-cell name="enabled" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.enabled == &quot;Y&quot; ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="flagNew" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.flagNew == &quot;Y&quot; ? &quot;fa-asterisk text-active&quot; : &quot;fa-asterisk text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="flagHit" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.flagHit == &quot;Y&quot; ? &quot;fa-star text-active&quot; : &quot;fa-star text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="isMarket" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.isMarket ? &quot;fa-money text-active&quot; : &quot;fa-money text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="specialOffer" style="max-width: 50px;">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchend="{handlers.permission(handlers.boolChange, &quot;products&quot;, &quot;0010&quot;)}" ontouchstart="{stopPropagation}" __disabled="{!handlers.checkPermission(&quot;products&quot;, &quot;0010&quot;)}"><i class="fa {row.specialOffer == &quot;Y&quot; ? &quot;fa-check text-active&quot; : &quot;fa-check text-noactive&quot;} "></i></button>\n          </datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', 'products-list,[riot-tag="products-list"],[data-is="products-list"]{ display: block; position: relative; } products-list .text-active,[riot-tag="products-list"] .text-active,[data-is="products-list"] .text-active{ color: #000; } products-list .text-noactive,[riot-tag="products-list"] .text-noactive,[data-is="products-list"] .text-noactive{ color: #ccc; } products-list .table td,[riot-tag="products-list"] .table td,[data-is="products-list"] .table td{ vertical-align: middle !important; }', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Product';
self.brands = [];
self.labels = [];
self.categoryFilters = false;

self.add = function (e) {
    /*
    * СОЗДАНИЕ ТОВАРА
    * получаем базовыю валюту
    * формируем данные: name, idGroup, idBrand, curr
    * передаем в Product Save
    */
    API.request({
        object: 'Main',
        method: 'Info',
        data: {},
        success: function success(response) {
            self.basecurr = response.basecurr;
            modals.create('product-new-modal', {
                type: 'modal-primary',
                submit: function submit() {
                    var _this = this;
                    var params = {
                        name: this.name.value,
                        idGroup: self.selectedCategory,
                        idBrand: self.selectedBrand,
                        curr: self.basecurr
                    };
                    _this.error = _this.validation.validate(_this.item, _this.rules);
                    if (!_this.error) {
                        API.request({
                            object: 'Product',
                            method: 'Save',
                            data: params,
                            success: function success(response, xhr) {
                                popups.create({ title: 'Успех!', text: 'Товар добавлен!', style: 'popup-success' });
                                _this.modalHide();
                                self.tags.catalog.reload();
                                if (response && response.id) riot.route('/products/' + response.id);
                            }
                        });
                    }
                }
            });
        }
    });
};
self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' },
//{ name:'price', value:'Цена'},
{ name: 'stock', value: 'Остаток' }, { name: 'nameBrand', value: 'Бренд' }, { name: 'nameGroup', value: 'Группа' }, { name: 'sort', value: 'Индекс' }, { name: 'enabled', value: 'Вид' }, { name: 'flagNew', value: 'Нв' }, { name: 'flagHit', value: 'Хит' }, { name: 'isMarket', value: 'ЯМ' }, { name: 'specialOffer', value: 'Спец.' }];

function afterChangeParent(idParent, id, position) {
    var params = {};
    params.id = id;
    params.upid = idParent;
    params.position = position;

    API.request({
        object: 'Category',
        method: 'Save',
        data: params,
        success: function success() {
            popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
        }
    });
}

function afterChangePosition(indexes) {
    var params = { indexes: indexes };
    API.request({
        object: 'Category',
        method: 'Sort',
        data: params,
        success: function success() {
            popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
        }
    });
}

self.handlersGroups = {
    afterChangeParent: afterChangeParent,
    afterChangePosition: afterChangePosition
};

// сохранение измененных через лист параметров
self.handlers = {
    checkPermission: self.checkPermission,
    permission: self.permission,
    boolChange: function boolChange(e) {
        var _this = this;
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (_this.opts.name == 'presenceCount') {
            this.row[this.opts.name] = e.target.value;
            _this.row[_this.opts.name] = e.target.value;
        } else if (_this.opts.name == 'isMarket') _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;else _this.row[_this.opts.name] = _this.row[_this.opts.name] === 'Y' ? 'N' : 'Y';

        self.update();

        var params = {};
        params.id = _this.row.id;
        params[_this.opts.name] = _this.row[_this.opts.name];

        params = self.tags.catalog.allParams(params);
        API.request({
            object: 'Product',
            method: 'Save',
            data: params,
            error: function error(response) {
                if (_this.opts.name == 'isMarket') _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;else _this.row[_this.opts.name] = _this.row[_this.opts.name] === 'Y' ? 'N' : 'Y';
                self.update();
            }
        });
    },

    // селекторы
    toggleSelected: function toggleSelected(e) {
        var field = e.target.getAttribute('data-field');

        var oldValues = {};
        var rows = this.tags.datatable.getSelectedRows();
        var ids = rows.map(function (item) {
            return item.id;
        });
        var newValue = rows[0][field] === 'Y' ? 'N' : 'Y';

        var params = self.tags.catalog.getSelectedMode();
        params[field] = newValue;

        rows.forEach(function (item) {
            var _oldValues$item$id;

            oldValues[item.id] = (_oldValues$item$id = {}, _oldValues$item$id[field] = item[field], _oldValues$item$id);
            item[field] = newValue;
        });
        API.request({
            object: 'Product',
            method: 'Save',
            data: params,
            error: function error(response) {
                rows.forEach(function (item) {
                    item[field] = oldValues[item.id][field];
                });

                self.update();
            }
        });
    },
    toggleBool: function toggleBool(e) {
        var field = e.target.getAttribute('data-field');
        var oldValues = {};
        var rows = this.tags.datatable.getSelectedRows();
        var ids = rows.map(function (item) {
            return item.id;
        });
        var newValue = rows[0][field] ? 0 : 1;

        var params = self.tags.catalog.getSelectedMode();
        params[field] = newValue;

        rows.forEach(function (item) {
            var _oldValues$item$id2;

            oldValues[item.id] = (_oldValues$item$id2 = {}, _oldValues$item$id2[field] = item[field], _oldValues$item$id2);
            item[field] = newValue;
        });
        API.request({
            object: 'Product',
            method: 'Save',
            data: params,
            error: function error(response) {
                rows.forEach(function (item) {
                    item[field] = oldValues[item.id][field];
                });
                self.update();
            }
        });
    },

    // МЕНЮ ДЕЙСТВИЙ
    // мультиредактирование товаров
    multiEdit: function multiEdit(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        }).join(',');
        riot.route('/products/multi?ids=' + ids);
    },

    // клонирование товара
    cloneProduct: function cloneProduct(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        }).join(',');
        riot.route('/products/clone?id=' + ids);
    },

    /*
    * ПЕРЕОПРЕДЕЛИТЬ КАТЕГОРИЮ
    * ids                    id выделенных товаров
    * items                    id выбранных категорий для товаров
    * items[0], params        данные выбраннОЙ категории для товаров
    */
    setCategory: function setCategory(e) {
        var _this = this;
        var params = {};

        var items = _this.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        params = { ids: ids };
        params = _this.allParams(params);

        modals.create('group-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var citems = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();

                if (citems.length > 0) {
                    params = (0, _extends3.default)({ idGroup: citems[0].id }, params);

                    console.log(params);

                    API.request({
                        object: 'Product',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            _this.reload();
                        }
                    });

                    self.update();
                    this.modalHide();
                }
            }
        });
    },

    /*
    * НАЗНАЧЕНИЕ ДОП.КАТЕГОРИЙ
    * ids                    id выделенных товаров
    * items, params            данные выбранных категорий для товаров
    * itemsCrossGroups        массивы с данными по доп.категориям (отправляются нумерованным массивом)
    */
    setAddCategory: function setAddCategory(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });

        modals.create('group-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();

                if (items.length > 0) {
                    var itemsCrossGroups = {};
                    for (var i = 0; i < items.length; i++) {
                        itemsCrossGroups[i] = items[i];
                    }var params = {
                        ids: ids,
                        crossGroups: itemsCrossGroups
                    };

                    params = self.tags.catalog.allParams(params);
                    API.request({
                        object: 'Product',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            self.tags.catalog.reload();
                        }
                    });

                    self.update();
                    this.modalHide();
                }
            }
        });
    },

    /** ДОБАВИТЬ ДОП.КАТЕГОРИИ
    * @param ids                id выделенных товаров
    * @param items, params      данные выбранных категорий для товаров
    */
    addCategory: function addCategory(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });

        modals.create('group-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();

                if (items.length > 0) {
                    var itemsCrossGroups = {};
                    for (var i = 0; i < items.length; i++) {
                        itemsCrossGroups[i] = items[i];
                    }var params = {
                        ids: ids,
                        crossGroups: itemsCrossGroups,
                        delCrosGroups: "False"
                    };

                    params = self.tags.catalog.allParams(params);
                    API.request({
                        object: 'Product',
                        method: 'Save',
                        data: params,
                        success: function success(response) {
                            self.tags.catalog.reload();
                        }
                    });

                    self.update();
                    this.modalHide();
                }
            }
        });
    },

    // добавить модификации
    addModifications: function addModifications(e) {
        var items = this.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        API.request({
            object: 'Product',
            method: 'Info',
            data: { id: items[0].id },
            success: function success(response) {
                var modifications = response.modifications;

                modals.create('product-edit-modifications-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    modifications: modifications,
                    submit: function submit() {
                        var _this = this;
                        var params = (0, _extends3.default)({ ids: ids, add: true }, this.item);
                        params = self.tags.catalog.allParams(params);
                        API.request({
                            object: 'Product',
                            method: 'Save',
                            data: params,
                            success: function success(response) {
                                _this.modalHide();
                                self.tags.catalog.reload();
                            }
                        });
                    }
                });
            }
        });
    },
    contextMenu: function contextMenu(Event, SelectedRow) {
        return true;
    },

    // задать модификации
    setModifications: function setModifications(e) {
        var items = this.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });

        API.request({
            object: 'Product',
            method: 'Info',
            data: { id: items[0].id },
            success: function success(response) {
                var modifications = response.modifications;

                modals.create('product-edit-modifications-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    modifications: modifications,
                    submit: function submit() {
                        var _this = this;
                        var params = (0, _extends3.default)({ ids: ids }, this.item);

                        params = self.tags.catalog.allParams(params);
                        API.request({
                            object: 'Product',
                            method: 'Save',
                            data: params,
                            success: function success(response) {
                                _this.modalHide();
                                self.tags.catalog.reload();
                            }
                        });
                    }
                });
            }
        });
    },

    // задать характеристики
    setFeatures: function setFeatures(e) {
        var items = this.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        var specifications = [];

        API.request({
            object: 'Product',
            method: 'Info',
            data: { id: ids, set: true },
            success: function success(response) {
                specifications = response;

                modals.create('product-edit-parameters-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    specifications: specifications,
                    submit: function submit() {
                        var _this = this;
                        var params = (0, _extends3.default)({ ids: ids }, this.item, { isAddSpecifications: false });

                        params = self.tags.catalog.allParams(params);
                        API.request({
                            object: 'Product',
                            method: 'Save',
                            data: params,
                            success: function success(response) {
                                _this.modalHide();
                                self.tags.catalog.reload();
                            }
                        });
                    }
                });
            }
        });
    },

    // добавить характеристики
    addFeatures: function addFeatures(e) {
        var items = this.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        //let specifications = []

        API.request({
            object: 'Product',
            method: 'Info',
            data: { id: ids, set: true },
            success: function success(response) {
                var specifications = response;

                modals.create('product-edit-parameters-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    specifications: specifications,
                    submit: function submit() {
                        var _this = this;
                        var params = (0, _extends3.default)({ ids: ids }, this.item, { isAddSpecifications: true });

                        params = self.tags.catalog.allParams(params);
                        API.request({
                            object: 'Product',
                            method: 'Save',
                            data: params,
                            success: function success(response) {
                                _this.modalHide();
                                self.tags.catalog.reload();
                            }
                        });
                    }
                });
            }
        });
    },

    // задать бренд
    setBrand: function setBrand(e) {
        var ids = this.tags.datatable.getSelectedRows().map(function (item) {
            return item.id;
        });
        var catalog = this;

        modals.create('brands-list-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();

                var params = self.tags.catalog.getSelectedMode();
                params['brand'] = { id: items[0].id, name: items[0].name };

                /* let params = { ids, brand: { id: items[0].id, name: items[0].name }};
                     params = catalog.allParams(params); */

                API.request({
                    object: 'Product',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags.catalog.reload();
                    }
                });

                self.update();
                this.modalHide();
            }
        });
    },

    // задать цену
    setPrice: function setPrice(e) {
        var items = self.tags.catalog.tags.datatable.getSelectedRows();
        var price = items[0].price;

        modals.create('price-modal', {
            type: 'modal-primary',
            price: price,
            submit: function submit() {
                var _this = this;
                var item = this.item;
                var ids = items.map(function (item) {
                    return item.id;
                });
                var params = (0, _extends3.default)({ ids: ids }, item);

                params = self.tags.catalog.allParams(params);
                API.request({
                    object: 'Product',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        });
    },
    showFeatures: function showFeatures(e) {
        var items = self.tags.catalog.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        var params = { ids: ids };
        params["isShowFeature"] = true;
        params = self.tags.catalog.allParams(params);
        API.request({
            object: 'Product',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
            }
        });
    },
    hideFeatures: function hideFeatures(e) {
        var items = self.tags.catalog.tags.datatable.getSelectedRows();
        var ids = items.map(function (item) {
            return item.id;
        });
        var params = { ids: ids };
        params["isShowFeature"] = false;
        params = self.tags.catalog.allParams(params);
        API.request({
            object: 'Product',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
            }
        });
    },

    // задать наценку
    setMarkup: function setMarkup(e) {
        modals.create('markup-modal', {
            type: 'modal-primary',
            submit: function submit() {
                var _this = this;
                var item = this.item;
                var params = self.tags.catalog.getSelectedMode();
                params.value = item.value;
                params.price = item.price;
                params.source = item.source;
                API.request({
                    object: 'Product',
                    method: 'AddPrice',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        });
    }
};

self.productOpen = function (e) {
    return riot.route('/products/' + e.item.row.id);
};

// получить бренды
self.getBrands = function () {
    API.request({
        object: 'Brand',
        method: 'Fetch',
        success: function success(response) {
            self.brands = response.items;
            self.update();
        }
    });
};

// получить ярлыки
self.getLabels = function () {
    API.request({
        object: 'ProductLabel',
        method: 'Fetch',
        success: function success(response) {
            self.labels = response.items;
            self.update();
        }
    });
};

self.selectBrand = function (e) {
    self.selectedBrand = e.target.value || undefined;
};

self.selectLabel = function (e) {
    self.selectLabel = e.target.value || undefined;
};

// перезагрузка каталога продуктов
observable.on('products-reload', function (item) {
    console.log(self.tags.catalog);
    // принимаем группы для фильтрации
    if (item && item.name) {
        (function () {
            self.update();
            var items = self.tags.catalog.items;
            if (items && items.length > 0) items.forEach(function (it, i) {
                if (it.__selected__) {
                    items[i].name = item.name;
                    items[i].article = item.article;
                    items[i].imageUrlPreview = item.imageUrlPreview;
                    items[i].price = item.price;
                    items[i].flagHit = item.flagHit;
                    items[i].flagNew = item.flagNew;
                    items[i].specialOffer = item.specialOffer;
                    items[i].nameGroup = item.nameGroup;
                    items[i].nameBrand = item.nameBrand;
                    items[i].presenceCount = item.presenceCount;
                    items[i].discount = item.discount;
                    items[i].isMarket = item.isMarket;
                    items[i].enabled = item.enabled;
                    return;
                }
            });
            //tags.datatable.getSelectedRows()
            //items[0] = item

            /*
            if (item.idGroup > 0) {
                let value = item.idGroup
                //items.map(i => i.id).join(',')
                self.categoryFilters = [{field: 'idGroup', sign: 'IN', value}]
            } else {
                self.categoryFilters = false
                self.selectedCategory = 0
            }
            */
            self.update();
        })();
    } else {
        self.update();
        self.tags.catalog.reload();
    }
});

// перезагрузка дерева категорий
observable.on('categories-reload', function (e) {
    self.tags['catalog-tree'].reload();
});

self.one('updated', function () {
    self.tags.catalog.on('reload', function () {
        self.getBrands();
        self.getLabels();
    });
    self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
        self.selectedCategory = node.__selected__ ? node.id : undefined;
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.id;
            }).join(',');
            self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];
        } else {
            self.categoryFilters = false;
            self.selectedCategory = 0;
        }
        self.update();
        self.tags.catalog.reload();
    });
});

self.import = {};

observable.on('products-imports', function () {
    modals.create('import-products-modal-continue', {
        type: 'modal-primary'
    });
});
observable.on('products-imports-end', function () {
    modal.modalHide();
});

self.importProducts = function (e) {
    modals.create('import-products-modal', {
        type: 'modal-primary',
        idGroup: self.selectedCategory
    });
    //var formData = new FormData();
    //for (var i = 0; i < e.target.files.length; i++) {
    //   formData.append('file' + i, e.target.files[i], e.target.files[i].name)
    //}
    //
    //API.upload({
    //    object: 'Product',
    //    data: formData,
    //    success(response) {
    //        self.update();
    //    }
    //})
};

self.exportProducts = function (e) {
    var items = self.tags.catalog.tags.datatable.getSelectedRows();
    var ids = items.map(function (item) {
        return item.id;
    });
    var params = {};
    if (ids) {
        params = { ids: ids };
    }
    params = self.tags.catalog.allParams(params);
    modals.create('export-products-modal', {
        type: 'modal-primary',
        idGroup: self.selectedCategory,
        params: params
    });
};

self.getBrands();
self.getLabels();
});


// WEBPACK FOOTER //
// ./pages/products/products/products-list.tag